"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var errors_1 = require("./errors");
/**
 * Owner Olympus client
 */
var ClientInstance = /** @class */ (function () {
    function ClientInstance(baseURL, getRequestSettings, _a) {
        var _b = _a === void 0 ? {} : _a, defaultHeaders = _b.defaultHeaders, onRequestError = _b.onRequestError, onResponseError = _b.onResponseError, formatRequest = _b.formatRequest, formatResponse = _b.formatResponse;
        var _this = this;
        var headers = __assign({ Accept: 'application/json' }, defaultHeaders);
        this.instance = axios_1.default.create({
            baseURL: baseURL,
            headers: headers,
            withCredentials: true,
        });
        this.instance.interceptors.request.use(function (req) { return __awaiter(_this, void 0, void 0, function () {
            var _a, audience, client, csrfToken, bearerToken;
            var _b, _c, _d, _e, _f, _g, _h, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0: return [4 /*yield*/, getRequestSettings()];
                    case 1:
                        _a = _k.sent(), audience = _a.audience, client = _a.client, csrfToken = _a.csrfToken, bearerToken = _a.bearerToken;
                        if (audience) {
                            req.headers['X-PB-Audience'] =
                                (_c = (_b = req.headers) === null || _b === void 0 ? void 0 : _b['X-PB-Audience']) !== null && _c !== void 0 ? _c : audience;
                        }
                        if (client) {
                            req.headers['X-PB-Client'] = (_e = (_d = req.headers) === null || _d === void 0 ? void 0 : _d['X-PB-Client']) !== null && _e !== void 0 ? _e : client;
                        }
                        if (csrfToken) {
                            req.headers['X-CSRFToken'] = (_g = (_f = req.headers) === null || _f === void 0 ? void 0 : _f['X-CSRFToken']) !== null && _g !== void 0 ? _g : csrfToken;
                        }
                        if (bearerToken) {
                            req.headers.authorization = ((_h = req.headers) === null || _h === void 0 ? void 0 : _h.Authorization)
                                ? ["Bearer ".concat(bearerToken), (_j = req.headers) === null || _j === void 0 ? void 0 : _j.Authorization].join(', ')
                                : "Bearer ".concat(bearerToken);
                        }
                        if (!formatRequest) return [3 /*break*/, 3];
                        return [4 /*yield*/, formatRequest(req)];
                    case 2:
                        req = _k.sent();
                        _k.label = 3;
                    case 3: return [2 /*return*/, req];
                }
            });
        }); }, onRequestError);
        if (formatResponse || onResponseError)
            this.instance.interceptors.response.use(formatResponse, onResponseError);
    }
    ClientInstance.prototype.exec = function (method, path, req, knownErrors) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_1, _a, code, message, status_1, payload;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.send(method, path, req)];
                    case 1:
                        data = (_d.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        error_1 = _d.sent();
                        if (axios_1.default.isAxiosError(error_1) &&
                            knownErrors.includes((_b = error_1.response) === null || _b === void 0 ? void 0 : _b.data.code)) {
                            _a = (_c = error_1.response) === null || _c === void 0 ? void 0 : _c.data, code = _a.code, message = _a.message, status_1 = _a.status, payload = _a.payload;
                            throw new errors_1.ClientError(code, message, status_1, payload);
                        }
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClientInstance.prototype.send = function (method, basePath, req) {
        return __awaiter(this, void 0, void 0, function () {
            var options, path, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        options = {
                            headers: req.headers,
                        };
                        if (req.query && Object.keys(req.query).length) {
                            options.params = req.query;
                        }
                        path = this.formatPath(basePath, req);
                        _a = method;
                        switch (_a) {
                            case 'DELETE': return [3 /*break*/, 1];
                            case 'GET': return [3 /*break*/, 3];
                            case 'PATCH': return [3 /*break*/, 5];
                            case 'POST': return [3 /*break*/, 7];
                            case 'PUT': return [3 /*break*/, 9];
                        }
                        return [3 /*break*/, 11];
                    case 1: return [4 /*yield*/, this.instance.delete(path, options)];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3: return [4 /*yield*/, this.instance.get(path, options)];
                    case 4: return [2 /*return*/, _b.sent()];
                    case 5: return [4 /*yield*/, this.instance.patch(path, req.body, options)];
                    case 6: return [2 /*return*/, _b.sent()];
                    case 7: return [4 /*yield*/, this.instance.post(path, req.body, options)];
                    case 8: return [2 /*return*/, _b.sent()];
                    case 9: return [4 /*yield*/, this.instance.put(path, req.body, options)];
                    case 10: return [2 /*return*/, _b.sent()];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    ClientInstance.prototype.formatPath = function (path, request) {
        var _a;
        for (var _i = 0, _b = Object.entries((_a = request.params) !== null && _a !== void 0 ? _a : {}); _i < _b.length; _i++) {
            var _c = _b[_i], key = _c[0], value = _c[1];
            path = path.replace("{".concat(key, "}"), value);
        }
        return path;
    };
    return ClientInstance;
}());
exports.default = ClientInstance;
//# sourceMappingURL=instance.js.map